<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider
      width="256"
      :collapsed="collapsed"
      :trigger="null"
      collapsible
      style="box-shadow: 2px 0 6px rgba(0,21,41,.35);">
      <div class="ant-pro-sider-menu-logo">
        <h1 v-show="!collapsed" style="font-size:30px">LAMA</h1>
      </div>
      <side-bar :is-collapse="collapsed">
      </side-bar>
    </a-layout-sider>
    <a-layout class="main-panel">
      <a-layout-header
        class="layout-header">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="handleCollapsedChange"
        />
        <right-content/>
      </a-layout-header>
      <page-header/>
      <a-layout-content
        class="main-content"
        :style="{ padding: displayPageHeader?'16px 16px':'', background: '#f0f2f5'}"
      >
        <router-view/>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue';
import RightContent from '@/components/globalHeader/RightContent.vue';
import SideBar from './SideBar.vue';

export default {
  components: {
    RightContent,
    PageHeader,
    SideBar,
  },
  data() {
    return {
      collapsed: this.$store.state.collapsed,
      isFullScreen: false,
      displayPageHeader: false,
    };
  },
  watch: {
    $route(val) {
      this.displayPageHeader = val.meta.displayPageHeader;
    },
  },
  created() {
    this.displayPageHeader = this.$route.meta.displayPageHeader;
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
  },
  methods: {
    handleCollapsedChange() {
      this.collapsed = !this.collapsed;
      this.$store.commit('changeCollapsed', this.collapsed);
    },
  },
};
</script>
<style scoped>
.ant-pro-sider-menu-logo {
  position: relative;
  height: 64px;
  padding-left: 24px;
  padding-right: 24px;
  overflow: hidden;
  transition: all 0.3s;
  line-height: 64px;
  background: #001529;
}

.ant-pro-sider-menu-logo svg, .ant-pro-sider-menu-logo img {
  height: 32px;
  width: 32px;
  vertical-align: middle;
}

.ant-pro-sider-menu-logo svg, .ant-pro-sider-menu-logo img, .ant-pro-sider-menu-logo h1 {
  display: inline-block;
}

.ant-pro-sider-menu-logo h1 {
  color: #fff;
  font-size: 20px;
  margin: 0 0 0 12px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  font-weight: 600;
  vertical-align: middle;
}

.ant-pro-sider-menu-logo svg, .ant-pro-sider-menu-logo img, .ant-pro-sider-menu-logo h1 {
  display: inline-block;
}

.aside {
  padding-top: 5px;
  height: calc(100vh - 80px);
  border-right: 1px solid #eeeeee;
  transition: width 0.3s, transform 2s;
  background-color: #001529;
}

.header {
  line-height: 80px;
  height: 80px;
  box-shadow: 1px 0 20px 0 #61616124;
  /*box-shadow: #efefef 0 1px 1px;*/
  /*background: #27496d;*/
}

.main-wrap {
  height: calc(100vh - 100px);
  overflow: auto;
  margin: 10px;
}

.router-title {
  font-weight: 400;
  color: #606266;
  cursor: text;
  font-size: 25px;
  line-height: 60px;
  height: 64px;
  display: inline-block;
  padding: 0;
  vertical-align: -0.125em;
}

.main-panel {
  height: 100vh;
}

.main-content {
  overflow: auto;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  background: #ffffff;
  height: 64px;
  color: rgb(0 0 0);
  /* background: rgba(255, 255, 255, 0.2); */
  padding: 16px;
  /* margin-bottom: 16px; */
}

#components-layout-demo-custom-trigger .logo h1 {
  display: inline-block;
  color: #000;
  font-size: 20px;
  transition: visibility 0.3s;
  margin: 0 0 0 12px;
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
  font-weight: 600;
  overflow-wrap: anywhere;
  vertical-align: initial;
}

.logo:after {
  position: absolute;
  left: -100%; /*改变left的值，让其相对box影藏*/
  top: 0;
  width: 30%;
  height: 100%;
  content: "";
  transition: 1s ease;
}

.layout-header {
  background: #fff;
  padding: 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  z-index: 10;
}
</style>
